import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Stack, Text } from "braid-design-system";
import { Callout } from "../Callout/Callout.mjs";
import { translations } from "../../../../HirerContractBalance/components/Contract/.vocab/index.mjs";
import { formatMinorUnits } from "@seek/currency";
import { useContext } from "react";
import { HirerBalanceContext } from "../../HirerBalancePresentation.mjs";
import { Remaining, BadgeComponent, formatExpiryDate } from "../BalanceCarousel/BalanceCarouselWrapper.mjs";
import { callout } from "./ContractBalanceBreakdown.css.mjs";
const ActiveContract = ({
  isDollarValue,
  warningType,
  daysLeft,
  totalValue,
  expiryDateUtc,
  label
}) => {
  var _a;
  const { t } = useTranslations(translations);
  const hasValidExpiryDate = !expiryDateUtc.startsWith("9999");
  const currency = totalValue.dollars.remaining.currency;
  const { locale } = useContext(HirerBalanceContext);
  const remainingValue = isDollarValue ? totalValue.dollars.remaining.value ?? 0 : ((_a = totalValue.units) == null ? void 0 : _a.remaining) ?? 0;
  const isCompactPrice = remainingValue.toString().length >= 9;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      marginTop: "small",
      children: [
        /* @__PURE__ */ jsx(
          Remaining,
          {
            isDollarValue,
            warningType,
            totalValue
          }
        ),
        /* @__PURE__ */ jsx(Box, { marginY: "xsmall", marginX: "xsmall", children: /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
          warningType !== "NoWarning" && /* @__PURE__ */ jsx(BadgeComponent, { daysLeft, warningType }),
          /* @__PURE__ */ jsx(Text, { size: "small", children: label }),
          isCompactPrice && /* @__PURE__ */ jsxs(Text, { size: "small", children: [
            formatMinorUnits(Math.floor(remainingValue), {
              currency,
              locale,
              dropFraction: true
            }),
            t("remaining")
          ] }),
          hasValidExpiryDate ? /* @__PURE__ */ jsx(Text, { size: "small", children: t("Expires date", { date: formatExpiryDate(expiryDateUtc) }) }) : /* @__PURE__ */ jsx(Text, { size: "small", tone: "secondary", children: t("Not started") })
        ] }) })
      ]
    }
  );
};
const StackedContract = ({
  totalValue,
  label,
  isDollarValue
}) => {
  var _a;
  const { t } = useTranslations(translations);
  const currency = totalValue.dollars.remaining.currency;
  const { locale } = useContext(HirerBalanceContext);
  const remainingValue = isDollarValue ? totalValue.dollars.remaining.value ?? 0 : ((_a = totalValue.units) == null ? void 0 : _a.remaining) ?? 0;
  const isCompactPrice = remainingValue.toString().length >= 9;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      marginTop: "small",
      children: [
        /* @__PURE__ */ jsx(
          Remaining,
          {
            totalValue,
            warningType: "NoWarning",
            isDollarValue
          }
        ),
        /* @__PURE__ */ jsx(Box, { marginY: "xsmall", marginX: "xsmall", children: /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
          /* @__PURE__ */ jsx(Text, { size: "small", children: label }),
          isCompactPrice === true && /* @__PURE__ */ jsx(Text, { size: "small", children: formatMinorUnits(Math.floor(remainingValue), {
            currency,
            locale,
            dropFraction: true
          }) }),
          /* @__PURE__ */ jsx(Text, { size: "small", tone: "secondary", children: t("Not started") })
        ] }) })
      ]
    }
  );
};
const ContractBalanceBreakdown = ({
  contractBalance,
  warningType
}) => {
  const { t } = useTranslations(translations);
  const { contracts, dollarBased, title } = contractBalance;
  const activeContracts = (contracts == null ? void 0 : contracts.filter((x) => x.current)) ?? [];
  const stackedContracts = (contracts == null ? void 0 : contracts.filter((x) => !x.current)) ?? [];
  return /* @__PURE__ */ jsxs(Callout, { className: callout, position: "left", children: [
    /* @__PURE__ */ jsx(Text, { weight: "strong", children: t("Balance breakdown") }),
    /* @__PURE__ */ jsxs(Box, { marginTop: "small", children: [
      activeContracts.map((contract, index) => {
        const {
          expiry: { daysRemaining, expiryDate },
          value
        } = contract;
        return /* @__PURE__ */ jsx(
          ActiveContract,
          {
            isDollarValue: dollarBased,
            warningType,
            daysLeft: daysRemaining,
            expiryDateUtc: expiryDate,
            label: title,
            totalValue: value
          },
          index
        );
      }),
      stackedContracts.map((contract, index) => {
        const { value } = contract;
        return /* @__PURE__ */ jsx(
          StackedContract,
          {
            isDollarValue: dollarBased,
            label: title,
            totalValue: value
          },
          index
        );
      })
    ] })
  ] });
};
export {
  ContractBalanceBreakdown
};
